import React from "react";
import { Navigate, useParams } from "react-router-dom";

/** Legacy URL: forwards to transportation route view with daily template context. */
const ViewDailyTemplateRoute = () => {
  const { id, routeId } = useParams();
  if (!id || !routeId) return null;
  const qs = new URLSearchParams({ dailyTemplateId: id });
  return <Navigate to={`/trans-routes/${encodeURIComponent(routeId)}?${qs.toString()}`} replace />;
};

export default ViewDailyTemplateRoute;
